import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const r = ({
  title: l,
  titleId: o,
  ...c
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M512 960c247.424 0 448-200.576 448-448S759.424 64 512 64 64 264.576 64 512s200.576 448 448 448m19.183-392.695c-2.91 15.119-14.547 27.49-31.279 27.49h-4.363c-16.732 0-29.097-11.684-31.279-27.49l-7.275-59.1c-2.908-18.554 8.73-32.299 28.369-34.359 68.375-6.185 106.199-30.925 106.199-74.219v-1.374c0-38.485-31.277-65.286-83.65-65.286-38.551 0-69.83 13.058-98.925 37.798-7.275 5.498-16.73 9.619-26.914 9.619-22.549 0-40.734-17.18-40.734-37.796 0-10.308 4.365-21.303 14.547-29.549C394.43 278.677 443.166 256 510.087 256c101.835 0 170.938 53.602 170.938 139.503v1.374c0 86.59-66.193 125.76-146.933 138.816zm-87.288 131.944v-6.871c0-26.801 21.822-47.418 51.646-47.418 29.822 0 51.644 20.617 51.644 47.418v6.871c0 26.801-21.822 47.418-51.644 47.418-29.824 0-51.646-20.617-51.646-47.418",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = i(r);
export {
  n as default
};
